import { render, staticRenderFns } from "./store_goods_list.vue?vue&type=template&id=075eb872&scoped=true"
import script from "./store_goods_list.vue?vue&type=script&lang=js"
export * from "./store_goods_list.vue?vue&type=script&lang=js"
import style0 from "./store_goods_list.vue?vue&type=style&index=0&id=075eb872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075eb872",
  null
  
)

export default component.exports